import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronDoubleLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-double-left"><path d="M10 8L6 12L10 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17 8L13 12L17 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChevronDoubleLeft;
